import React from 'react';

import styled from 'styled-components';

import HeroHeading from 'components/hero-heading';
import Picture from 'components/picture';
import { useFeatureLayout } from 'hooks/use-feature-layout';

import Top from './top';

// Temporarily use important to override pagewide styles
const StyledHeroHeading = styled(HeroHeading)`
  font-size: 3.25rem !important;
  padding: 2rem !important;
  color: ${Styles.color.white};

  ${Styles.desktop`
    text-align: center !important;
    font-size: 6.25rem !important;
    padding: 4rem 0 2rem !important;
  `}
`;

const Container = styled.div`
  width: 90%;
  max-width: 920px;
  max-width: 1100px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
`;
const Heading = styled.h1`
  letter-spacing: -2px;
  font-weight: 900;
  line-height: 1em;
  color: ${Styles.color.white};
  text-align: center;
  margin: 0;
  padding: 0;
  font-size: 3rem;
  order: 2;
`;
const Tagline = styled.h2`
  font-family: ${Styles.fontFamily.brand};
  font-weight: ${Styles.fontWeight.normal};
  position: relative;
  left: 50%;
  display: inline-block;
  transform-origin: 0% 0%;
  transform: rotate(-5deg) translateX(-50%) translateY(0%);
  color: ${Styles.color.white};
  text-align: center;
  margin: 0;
  padding: 0;
  font-size: 3rem;
  order: 1;
`;

const Bottom = styled.div`
  padding: 0rem 0rem 3rem;
  ${Styles.mobile`
    padding: 0rem 0rem 2rem;
  `}
`;
const ImageContainer = styled.div`
  position: relative;
  width: 100%;
  overflow: hidden;
  border-radius: 4px;
  padding-bottom: 50%;
  border-radius: ${Styles.borderRadius};
  margin-top: -21rem;
  ${Styles.mobile`
    margin-top: -13rem;
  `}
  ${Styles.mobileSmall`
    margin-top: -8rem;
  `}
`;
const Image = styled(Picture)`
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
  position: absolute;
`;

const Header = ({ taglineContent, headerImage, headingContent }) => {
  const { featureLayout } = useFeatureLayout();
  const { locale: defaultHeroImage } = featureLayout?.defaultHeroImage || {};

  return taglineContent?.locale && headerImage ? (
    <>
      <Top>
        <Container>
          <Heading>{headingContent?.locale}</Heading>
          {taglineContent && <Tagline>{taglineContent?.locale}</Tagline>}
        </Container>
      </Top>
      <Bottom>
        <Container>
          <ImageContainer>
            <Image image={headerImage?.locale} />
          </ImageContainer>
        </Container>
      </Bottom>
    </>
  ) : (
    <Picture image={defaultHeroImage} alt="">
      <StyledHeroHeading as="h1">{headingContent?.locale}</StyledHeroHeading>
    </Picture>
  );
};

export default Header;
